import React from 'react';
import { FaEnvelope, FaLinkedinIn, FaGithub, FaFileAlt } from 'react-icons/fa';
import { FadeIn } from './animations/MotionPrimitives';
import { SOCIALS } from './Navigation';
import MailboxScene from './illustrations/MailboxScene';
import resume from './assets/Adiba_Akter_resume.pdf';
import './styles/Contact.css';

const LINKS = [
  {
    icon: <FaEnvelope aria-hidden="true" />,
    label: 'Email Me',
    sub: SOCIALS.email,
    href: `mailto:${SOCIALS.email}`,
    tone: 'blush',
  },
  {
    icon: <FaLinkedinIn aria-hidden="true" />,
    label: 'LinkedIn',
    sub: 'in/adiba-akter',
    href: SOCIALS.linkedin,
    external: true,
    tone: 'blue',
  },
  {
    icon: <FaGithub aria-hidden="true" />,
    label: 'GitHub',
    sub: 'github.com/AdibaAdi',
    href: SOCIALS.github,
    external: true,
    tone: 'lav',
  },
  {
    icon: <FaFileAlt aria-hidden="true" />,
    label: 'Résumé',
    sub: 'View PDF',
    href: resume,
    external: true,
    tone: 'gold',
  },
];

function Contact() {
  return (
    <section className="section contact" id="contact">
      <div className="section-inner">
        <div className="contact-grid">
          <FadeIn className="contact-copy chapter-head contact-head">
            <span className="chapter-mark">07</span>
            <h2 className="chapter-title">Contact</h2>
            <p className="contact-statement">Send a letter my way.</p>
            <p className="contact-text">
              The courier&apos;s last stop. I&apos;m open to full-time Software Engineering
              and AI Engineering roles starting January 2027.
            </p>

            <div className="contact-links">
              {LINKS.map((link) => (
                <a
                  key={link.label}
                  className={`contact-badge contact-badge--${link.tone}`}
                  href={link.href}
                  {...(link.external
                    ? { target: '_blank', rel: 'noopener noreferrer' }
                    : {})}
                >
                  <span className="contact-badge-icon">{link.icon}</span>
                  <span className="contact-badge-text">
                    <span className="contact-badge-label">{link.label}</span>
                    <span className="contact-badge-sub">{link.sub}</span>
                  </span>
                </a>
              ))}
            </div>
          </FadeIn>

          <FadeIn className="contact-scene" delay={0.1}>
            <MailboxScene />
          </FadeIn>
        </div>
      </div>
    </section>
  );
}

export default Contact;
